import { render, staticRenderFns } from "./selectWorkCategoryModal.vue?vue&type=template&id=45e83dce&"
import script from "./selectWorkCategoryModal.vue?vue&type=script&lang=ts&"
export * from "./selectWorkCategoryModal.vue?vue&type=script&lang=ts&"
import style0 from "./selectWorkCategoryModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports